import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState } from "react";
import NewAxiosInstance from "../../api/api";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { voicebotLogsApi } from "../../store/saga/requests/voicebotRequests";
import { CircularProgress } from "@mui/material";

export interface IVoiceBotForm {
  phoneNumber: string;
  policyNumber: string;
  annualPremium: number | null;
  policyCover: number | null;
}
export default function Voicebot() {
  const initialValues: IVoiceBotForm = {
    policyCover: null,
    phoneNumber: "",
    policyNumber: "",
    annualPremium: null,
  };
  // const [counter, setCounter] = useState(5);
  const [logPhoneNumber, setLogPhoneNumber] = useState<string | null>();
  const [log, setLog] = useState([]);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .strict(true)
      .required("Please enter Phone Number"),
    annualPremium: Yup.number()
      .strict(true)
      .required("Please enter Premium Amount"),
    policyCover: Yup.number().strict(true).required("Please enter Life Cover"),
    policyNumber: Yup.string()
      .trim("Please remove leading and trailing whitespace")
      .strict(true)
      .required("Policy Number is required."),
  });
  // function startCounter(phoneNumber: number) {
  //   let counter = 5;
  //   const intervalId = setInterval(() => {
  //     console.log(`Countdown: ${counter}s`);

  //     if (counter === 0) {
  //       console.log(phoneNumber, fetchLogs);
  //       clearInterval(intervalId);
  //       if (fetchLogs) getCallLogs(phoneNumber);
  //     }

  //     counter--;
  //   }, 1000);
  // }
  async function getCallLogs(phoneNumber: string) {
    await voicebotLogsApi(phoneNumber)
      .then((data) => {
        toast.success("Logs Updated", {
          duration: 3000,
        });
        setLog(data.data);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  }
  return (
    <div>
      {/* <div className="font-semibold	text-2xl">Voice Bot</div> */}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          if (loading) return;
          setLoading(true);
          setLog([]);
          setLogPhoneNumber(null);
          NewAxiosInstance()
            .post("crm/voicebot/call", values)
            .then((data) => {
              toast.success(data.data, {
                duration: 3000,
              });
              setLogPhoneNumber(values.phoneNumber);
            })
            .catch((error) => {
              toast.error(error?.response?.data?.message, {
                duration: 3000,
              });
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        {(formikProps) => (
          <>
            {/* {console.log(formikProps)}{" "} */}
            <Form className="flex gap-8   items-center  w-[100%]  flex-wrap justify-center">
              <div className="">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Phone Number *
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="phoneNumber"
                      name="phoneNumber"
                      type="text"
                      //   placeholder="Jane"
                    />
                    <ErrorMessage
                      component="div"
                      name="phoneNumber"
                      className="text-red-500 text-xs "
                    />
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Policy Number *
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="policyNumber"
                      name="policyNumber"
                      type="text"
                      //   placeholder="Doe"
                    />
                    <ErrorMessage
                      component="div"
                      name="policyNumber"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>

                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Life Cover Amount *
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      // className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      id="policyCover"
                      name="policyCover"
                      type="number"
                      //   placeholder="Jane"
                    />
                    <ErrorMessage
                      component="div"
                      name="policyCover"
                      className="text-red-500 text-xs "
                    />
                    {/* <p className="text-red-500 text-xs ">
                    Please fill out this field.
                  </p> */}
                  </div>
                  <div className="w-full md:w-1/2 px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Premium Amount *
                    </label>
                    <Field
                      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                      id="annualPremium"
                      name="annualPremium"
                      type="number"

                      //   placeholder="Doe"
                    />{" "}
                    <ErrorMessage
                      component="div"
                      name="annualPremium"
                      className="text-red-500 text-xs "
                    />
                  </div>
                </div>
              </div>
              <button
                onClick={() => {}}
                className={`bg-primary-dark px-4 py-2 rounded-md text-white text-[1.1rem] font-[500] ml-5 w-[150px] ${
                  loading && "bg-slate-50 "
                }`}
                // type="submit"
              >
                {loading ? (
                  <>
                    <CircularProgress color="secondary" size={20} />{" "}
                    <span className="text-black">Loading</span>
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </Form>
            {logPhoneNumber && (
              <div className="w-full flex flex-col justify-center items-center ">
                {" "}
                <div className="mb-3">
                  Latest Log for call on {logPhoneNumber}
                </div>
                <button
                  onClick={() => {
                    if (logPhoneNumber) getCallLogs(logPhoneNumber);
                  }}
                  className="bg-white px-4 py-2 rounded-md text-primary-dark text-[1.1rem] font-[500] ml-5 w-[170px]"
                  // type="submit"
                >
                  Fetch Latest Log
                </button>
                <ol className="md:mx-[25%]">
                  {" "}
                  {log && log.map((item, index) => <li key={index}>{item}</li>)}
                </ol>
              </div>
            )}
          </>
        )}
      </Formik>
    </div>
  );
}
